import { useUnmountEffect } from 'motion/react'
import { useContext, useEffect, useRef } from 'react'

import { LoadingContext } from './context'
import { LoadingContextProps } from './types'

const useLoader = (loading?: boolean): LoadingContextProps => {
  const initial = useRef(true)
  const { isLoading, showLoader, hideLoader } = useContext(LoadingContext)
  const show = useRef(showLoader)
  const hide = useRef(hideLoader)
  const loadingRef = useRef(loading)

  useEffect(() => {
    loadingRef.current = loading
  }, [loading])

  useEffect(() => {
    if (initial.current) {
      setTimeout(() => {
        if (loadingRef.current) show.current()
      }, 3000)
      initial.current = false
    } else {
      if (loadingRef.current) show.current()
      else hide.current()
    }
  }, [loading])

  useUnmountEffect(() => {
    hideLoader()
  })

  return { isLoading, showLoader, hideLoader }
}

export default useLoader
